module.exports = __webpack_public_path__ + "img/multiple.f27f9c1b.svg";